import { combineReducers, createStore } from 'redux'
import { ModuleReducer } from './modules/ModuleReducer'
import { AuthReducer } from './auth/AuthReducer'
import { AlertReducer } from './alert/AlertReducer'

const rootReducer = combineReducers({ AuthReducer, AlertReducer, ModuleReducer })
export type StoreState = ReturnType<typeof rootReducer>

const store = createStore(rootReducer)
export default store